import React, { useRef } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    Stack
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import api from '../../../api';
import { getBackendUrl } from '../../../util/envFn';
type CVUploadProps = {
    userData: any;
    setUserData: (data: any) => void;
    editMode: boolean;
};

const CVUpload: React.FC<CVUploadProps> = ({ userData, setUserData, editMode }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('cv', file);

        // Real API call implementation
        api.post(getBackendUrl(`/users/cv/${userData._id}`), formData)
            .then(res => res.data)
            .then(data => {
                setUserData({
                    ...userData,
                    cvUrl: data.cvUrl,
                    cvOriginalName: data.cvName,
                    cvUploadDate: new Date().toISOString()
                });
            })
            .catch(err => {
                console.error("Error uploading CV:", err);
            });
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleDownload = () => {
        if (userData.cvUrl) {
            window.open(getBackendUrl(userData.cvUrl), '_blank');
        }
    };

    return (
        <Stack>
            <Typography variant="h6" sx={{ mb: 2 }}>
                CV
            </Typography>

            {editMode ? (
                <Box>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".pdf,.doc,.docx"
                        style={{ display: 'none' }}
                        onChange={handleFileUpload}
                    />
                    <Button
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                        onClick={handleUploadClick}
                        sx={{ mb: 1 }}
                        fullWidth
                    >
                        {userData.cvUrl ? 'Replace CV' : 'Upload CV'}
                    </Button>

                    {userData.cvUrl && (
                        <Box sx={{ mt: 2 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <PictureAsPdfIcon color="error" />
                                <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                    {userData.cvOriginalName || 'CV.pdf'}
                                </Typography>
                            </Stack>
                        </Box>
                    )}
                </Box>
            ) : (
                <Box>
                    {userData.cvUrl ? (
                        <Box>
                            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
                                <PictureAsPdfIcon color="error" />
                                <Typography variant="body2" sx={{ flexGrow: 1 }}>
                                    {userData.cvOriginalName || 'CV.pdf'}
                                </Typography>
                            </Stack>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<FileDownloadIcon />}
                                onClick={handleDownload}
                            >
                                Download CV
                            </Button>
                        </Box>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No CV uploaded yet.
                        </Typography>
                    )}
                </Box>
            )}
        </Stack>
    );
};

export default CVUpload; 